import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-postgresql-details',
  templateUrl: './help-postgresql-details.component.html',
  styleUrls: ['./help-postgresql-details.component.scss']
})
export class HelpPostgresqlDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
